import React from 'react';
import SearchPage from './SearchPage';
import { fetchSearchPage } from '../../utils/lib';
import ListItemWAvatar from '../../layouts/ListItemWAvatar';
import { Box } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useConfig } from '../../providers/ConfigProvider';
import { useTranslation } from 'react-i18next';

const SearchOwner = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { config, isLoadingConfig } = useConfig();
  const { t } = useTranslation();
  
  const getSecondaryText = (item) => {
    const hasPhone = item?.phone && String(item.phone).trim() !== '';
    const hasEmail = item?.email && String(item.email).trim() !== '';
    
    if (!hasPhone && !hasEmail) return '';
    if (hasPhone && !hasEmail) return item.phone;
    if (hasEmail && !hasPhone) return item.email;
    return `${item.phone} | ${item.email}`;
  };

  const renderItem = (item) => (
    <Box
      sx={{
        width: '100%',
        cursor: 'pointer',
      }}
      onClick={() => handleOnClick(item)}
    >
      <ListItemWAvatar 
        key={item.id} 
        primary={item.name}
        secondary={getSecondaryText(item)}
        />
    </Box>
  );

  const handleOnClick = async (owner) => {
    const from = location.state?.from;
    if (from) {
      // navigate(from, { state: { owner } });
      navigate(from, { state: { owner }, replace: true });
    } else {
      // navigate('/main/view-owner', { state: { id: owner.id, updateLastView: true } });
      navigate('/main/view-owner', { state: { id: owner.id, updateLastView: true }, replace: true });
    }
  };

  if (isLoadingConfig) return (
    <>
      <CircularProgress
        size={42}
        sx={{ position: 'absolute', top: '50%', left: '50%', marginTop: '-21px', marginLeft: '-21px' }}
      />
    </>
  );


  return (
    <SearchPage
      fetchFunction={fetchSearchPage}
      table={'owners'}
      renderItem={renderItem}
      placeholder={t('search.searchOwner', { name: config.vet.owner_naming_es.toLowerCase() })}
    />
  );
};

export default SearchOwner;